import RedisConfig from './RedisConfig.jsx';

// React components that can be dynamically created by other components should be here
module.exports = {
  RedisConfig: RedisConfig,
};
